import AttachmentWellViewState from '../schema/AttachmentWellViewState';

export default function getAvailableLocalAttachmentSize(
    viewState: AttachmentWellViewState
): number {
    return viewState.maxTotalClassicAttachmentSize - viewState.totalClassicAttachmentSize;
}
